import Joi from '@hapi/joi'

export const LeafSupplierDetailsReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    factoryID: Joi.number().invalid(0).required().label("Factory").messages({
        "any.invalid": `Select Factory`,
        "any.required": `Factory required`
    }),
    routeID: Joi.number().invalid(0).label("Route").messages({
        "any.invalid": `Select Route`,
        "any.required": `Route required`
    }),
    qtyFrom: Joi.number().required().label("Qty From"),
    qtyTo: Joi.number().required().label("Qty To"),
    date: Joi.string().allow("", null).label("Date"),
}